import React from "react"
import { Modal, Form, Button } from "react-bootstrap"
import DualListBox from "../../components/Administration/DualListBox"
import ActionButton from "../ActionButton"
import AutoFilterLocation from "../../api/Location/LocationModel/AutoFilterLocation"

interface LocationSelectionProps {
  locations: AutoFilterLocation[]
  selectedLocations: AutoFilterLocation[]
  show: boolean
  onSave: (locations: AutoFilterLocation[]) => void
  onClose: () => void
}

interface LocationSelectionState {
  selectedLocations: AutoFilterLocation[]
}

export default class LocationSelection extends React.PureComponent<LocationSelectionProps, LocationSelectionState> {
  state: LocationSelectionState = {
    selectedLocations: []
  }

  onCancel = () => this.props.onClose()

  onSubmit = () => this.props.onSave(this.state.selectedLocations)

  render() {
    return (
      <Modal backdrop="static" show={this.props.show} size="xl">
        <Modal.Header>
          <Modal.Title className="text-uppercase">Locations</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="px-4">
            <DualListBox
              disabled={false}
              options={this.props.locations}
              selected={this.props.selectedLocations}
              idKey="AccountID"
              labelKey="Name"
              availableTitle="Possible Criteria"
              selectedTitle="Selected Criteria"
              onChange={selected => this.setState({ selectedLocations: [...selected] })}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.onCancel} className="px-4">Cancel</Button>
          <ActionButton onClick={this.onSubmit} className="px-4">Save</ActionButton>
        </Modal.Footer>
      </Modal>
    )
  }
}
